import Action, { ActionProps } from 'modules/Layout/component/Action/index';
import { ColorVariants } from 'modules/Shared/type';
import React from 'react';

const ActionPublish: React.FC<ActionProps> = ({
  label = <i className="far fa-arrow-alt-circle-up font-20" />,
  color = ColorVariants.Success,
  ...props
}: ActionProps): JSX.Element => {
  return (
    <Action
      {...props} // eslint-disable-line react/jsx-props-no-spreading
      label={label}
      color={color}
    />
  );
};

export default ActionPublish;
